import {useEffect, useLayoutEffect} from 'react';

/**
 *
 * @type {function(effect: React.EffectCallback, deps?: React.DependencyList): void}
 */
const useIsomorphicLayoutEffect =
    typeof window !== 'undefined' ? useLayoutEffect : useEffect;

export { useIsomorphicLayoutEffect as useLayoutEffect };

